<template>
    <div class="banner flexColumn">
        <div class="flex">
            <top-tab
                :topBarDatas="leftTopBarDatas"
            ></top-tab>
            <top-tab
                :topBarDatas="rightTopBarDatas"
            ></top-tab>
        </div>
        <div class="contentBox">
            <box-border
                title="0版文件跟踪"
                :boxStyle="{
                    'grid-row': '1 / span 2'
                }"
            >
                <span style="font-size: 0.16rem;color: #fc0;position: absolute; top: -0.1rem; right: 0.20rem;">
                    P: {{ submitted.otherObj.P }} A: {{ submitted.otherObj.A }} V: {{ submitted.otherObj.V }}
                </span>
                <echart-module
                    ref="submitted"
                    :option="submitted"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                title="本周文件状态"
                :boxStyle="{
                    'grid-row': '1 / span 3'
                }"
                ref="weekTable"
            >
                <thead-tbody
                    ref="refTable"
                    v-bind="documentWeek"
                >
                    <template #default="{ value, index }">
                        <span v-if="index == 'v8' || index == 'v5'" :style="{
                            'font-size': '0.12rem',
                            'display': 'line-block',
                            'width': '0.16rem',
                            'height': '0.16rem',
                            'vertical-align': 'middle',
                            'background-image': value > 0 ? `url(${getImg('img/upArrow')})` : ( value < 0 ? `url(${getImg('img/downArrow')})` : `url(${getImg('img/rightArrow')})`),
                            'background-size': '100% 100%'
                        }"></span>
                    </template>
                </thead-tbody>
            </box-border>
            <box-border
                title="0版文件状态"
                :boxStyle="{
                    'grid-row': '3 / span 2'
                }"
            >
                <echart-module
                    ref="docDiscipline"
                    :option="docDiscipline"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                title="MDR状态"
                :boxStyle="{
                    'grid-row': '4 / span 3'
                }"
                ref="mdrBoxBorder"
            >
                <thead-tbody
                    ref="StatusTable"
                    v-bind="mdrStatus"
                ></thead-tbody>
            </box-border>
            <box-border
                title="0版文件偏差"
                :boxStyle="{
                    'grid-row': '5 / span 2'
                }"
            >
                <echart-module
                    ref="varDiscipline"
                    :option="varDiscipline"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
        </div>
    </div>
</template>
<script>
    import { servedetail2UsingPOST } from '@/api/dataapi'
import { mapActions } from 'vuex';
    export default {
        name: 'Engineering',
        methods: {
            ...mapActions(['OPEN_TABLEBOX_DATAS']),
            getHeights(){
                const weekContent = this.$refs.weekTable.$refs.contentDiv.offsetHeight;
                const theadContent = this.$refs.refTable.$refs.tableThead.offsetHeight;
                this.documentWeek.height = weekContent - theadContent - 10 + 'px'

                const mdrStatusContent = this.$refs.mdrBoxBorder.$refs.contentDiv.offsetHeight;
                const mdrContent = this.$refs.StatusTable.$refs.tableThead.offsetHeight;
                this.mdrStatus.height = mdrStatusContent - mdrContent - 20 + 'px'
            }
        },
        mounted() {
            this.getHeights();
            window.onresize = this.getHeights;
        },
        destroyed() {
            window.onresize = () => false;
        },
        data(){
            const obj = {
                dataZoom: [
                    {
                        height: this.fontSizeFn(20),
                        moveHandleSize: 0,
                        bottom: 10,
                        textStyle: {
                            color: '#8392A5'
                        },
                        dataBackground: {
                        areaStyle: {
                            color: '#8392A5'
                        },
                        lineStyle: {
                            opacity: 0.8,
                            color: '#8392A5'
                        }
                        },
                        brushSelect: true
                    }, {
                        type: 'inside',
                        filterMode: 'filter'
                    }
                ]
            }
            return{
                //MDR Status
                mdrStatus: {
                    height: '100%',
                    theadDatas: [
                        [
                            { value: '专业' },
                            { value: '数量' },
                            { value: 'A' },
                            { value: 'B' },
                            { value: 'C' },
                            { value: '(0)' },
                            { value: '0' },
                        ]
                    ],
                    tbodyDatas: [],
                    keysArr: ['v1', 'v2', 'v3', 'v4', 'v5', 'v6', 'v7']
                },
                //Document for the Week
                documentWeek: {
                    height: '100%',
                    keysArr: ['v1', 'v2', 'v3', 'v4', 'v5', 'v6', 'v7', 'v8'],
                    otherArr: [
                        {
                            index: 'v8',
                            click: async(item) => {
                                const data = await this.getTableData('2c92808382d8cbaa0182d9b712020003', item.v1);
                                this.OPEN_TABLEBOX_DATAS(data);
                            }
                        },
                        {
                            index: 'v5',
                            click: async(item) => {
                                const data = await this.getTableData('2c92808f82ca073e0182cf0a102f0001', item.v1);
                                this.OPEN_TABLEBOX_DATAS(data);
                            }
                        }
                    ],
                    theadDatas: [
                        [
                            {
                                rowspan: '2',
                                value: '专业'
                            },
                            {
                                rowspan: '2',
                                value: '数量'
                            },
                            {
                                colspan: '3',
                                value: '累计'
                            },
                            {
                                colspan: '3',
                                value: '本周'
                            }
                        ],
                        [
                            {
                                value: '计划'
                            },
                            {
                                value: '实际'
                            },
                            {
                                value: '偏差'
                            },
                            {
                                value: '计划'
                            },
                            {
                                value: '实际'
                            },
                            {
                                value: '偏差'
                            }
                        ]
                    ],
                    tbodyDatas: [],
                },
                leftTopBarDatas: [
                    {
                        name: 'Overall',
                        fn: () => {
                            this.stype = 'Project';
                            this.getAllPromise(this.getxhrArr);
                        }
                    },
                    {
                        name: 'CPF & Wellpad & IFL',
                        fn: () => {
                            this.stype = 'CPF & Wellpad & IFL';
                            this.getAllPromise(this.getxhrArr);
                        }
                    },
                    {
                        name: 'WIS',
                        fn: () => {
                            this.stype = 'WIS';
                            this.getAllPromise(this.getxhrArr);
                        }
                    },
                    {
                        name: 'Temporary Camp',
                        fn: () => {
                            this.stype = 'TCP';
                            this.getAllPromise(this.getxhrArr);
                        }
                    }
                ],
                rightTopBarDatas: [
                    {
                        name: '累计',
                        fn: () => {
                            //三个图的id
                            this.allIds = {
                                discipline: '2c92808f828168cf0182901374b2003b',
                                mdrStatus: '2c92808f828168cf0182902bc38b003f',
                                variance: '2c92808f828168cf018290141893003d'
                            };
                            this.getAllPromise(this.bottomXhrArr);
                        }
                    },
                    {
                        name: '本周',
                        fn: () => {
                            //三个图的id
                            this.allIds = {
                                discipline: '2c92808f828168cf01829013be96003c',
                                mdrStatus: '2c92808f828168cf0182907252740040',
                                variance: '2c92808f828168cf018290145815003e'
                            };
                            this.getAllPromise(this.bottomXhrArr);
                        }
                    }
                ],
                allIds: {},
                stype: 'Project',
                // IFC Document Submitted
                submitted: {
                    otherObj: {
                        P: '',
                        A: '',
                        V: ''
                    },
                    grid: {
                        top: '15%',
                        bottom: this.fontSizeFn(35),
                        right: '2%'
                    },
                    color: [1, 0, 1, 0],
                    legend: {
                        top: '0%'
                    },
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].axisValue} <br />`;
                            datas.forEach((item, index) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                                if(index == 1){
                                    item.data.s5.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>累计偏差&nbsp;&nbsp;${item.data.s5}<br/>`)
                                }else if(index == 3){
                                    item.data.s6.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>本周偏差&nbsp;&nbsp;${item.data.s6}<br/>`)
                                }
                            })
                            return html;
                        }
                    },
                    ...obj
                },
                // Document by Discipline
                docDiscipline: {
                    grid: {
                        top: '15%',
                        bottom: '5%',
                        right: '2%'
                    },
                    color: [1, 0],
                    legend: {
                        top: '0%'
                    },
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].data['s1']} <br />`;
                            datas.forEach((item) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                            })
                            datas[0].data.s4.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>偏差&nbsp;&nbsp;${datas[0].data.s4}<br/>`)
                            return html;
                        }
                    }
                },
                // Variance by Discipline
                varDiscipline: {
                    grid: {
                        top: '15%',
                        bottom: '5%',
                        right: '2%'
                    },
                    yAxis: {
                        splitNumber: 2
                    },
                    color: [3],
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].data['s1']} <br />`;
                            datas.forEach((item) => {
                                if(typeof item.value === 'number'){
                                    html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                }
                            })
                            return html;
                        }
                    }
                },
                bottomXhrArr: [
                    //MDR Status
                    async () => {
                        this.mdrStatus.tbodyDatas = await servedetail2UsingPOST({
                            dataDetails: [
                                { chartid: this.allIds.mdrStatus, dataindex: 0, stype: this.stype }
                            ], modulename: 'uganda'
                        });
                    },
                    // Document by Discipline
                    async () => {
                        this.getNewVTos({
                            id: this.allIds.discipline,
                            stype: this.stype
                        },
                        [
                            ['计划', '实际'],
                            ['bar', 'bar'],
                            [0, 0]
                        ],
                        this.$refs.docDiscipline.myChart,
                        {
                            name: 'docDiscipline',
                            hasMoreData: ['s1', 's4'],
                            yAxisLines: 4,
                            startIndex: 2
                        }
                        )
                    },
                    // Variance by Discipline
                    async () => {
                        this.getNewVTos({
                            id: this.allIds.variance,
                            stype: this.stype
                        },
                        [
                            ['偏差'],
                            ['bar']
                        ],
                        this.$refs.varDiscipline.myChart,
                        {
                            name: 'varDiscipline',
                            hasMoreData: ['s1'],
                            startIndex: 2
                        }
                        )
                    }
                ],
                getxhrArr: [
                    // IFC Document Submitted
                    async () => {
                        this.getNewVTos({
                            id: '2c92808f828168cf01828fbb7de00020',
                            stype: this.stype
                        },
                        [
                            ['累计计划', '累计实际', '本周计划', '本周实际'],
                            ['line', 'line', 'bar', 'bar'],
                            [1, 1, 0, 0]
                        ],
                        this.$refs.submitted.myChart,
                        {
                            name: 'submitted',
                            hasMoreData: ['s5', 's6'],
                            yAxisLines: 4
                        },
                        (res) => {
                            this.$nextTick(() => {
                                const dataIndex = res.s2.findLastIndex(item => item !== ' ');
                                this.$set(this.submitted.otherObj, 'P', res.s1[dataIndex]);
                                this.$set(this.submitted.otherObj, 'A', res.s2[dataIndex]);
                                this.$set(this.submitted.otherObj, 'V', res.s5[dataIndex]);
                            })
                        }
                        )
                    },
                    // Document for the Week
                    async () => {
                        this.documentWeek.tbodyDatas = await servedetail2UsingPOST({
                            dataDetails: [
                                { chartid: '2c92808f828168cf01828fd9cb0c0021', dataindex: 0, stype: this.stype }
                            ], modulename: 'uganda'
                        });
                    },
                    //MDR Status
                    async () => {
                        this.mdrStatus.tbodyDatas = await servedetail2UsingPOST({
                            dataDetails: [
                                { chartid: this.allIds.mdrStatus, dataindex: 0, stype: this.stype }
                            ], modulename: 'uganda'
                        });
                    },
                    // Document by Discipline
                    async () => {
                        this.getNewVTos({
                            id: this.allIds.discipline,
                            stype: this.stype
                        },
                        [
                            ['计划', '实际'],
                            ['bar', 'bar'],
                            [0, 0]
                        ],
                        this.$refs.docDiscipline.myChart,
                        {
                            name: 'docDiscipline',
                            hasMoreData: ['s1', 's4'],
                            yAxisLines: 4,
                            startIndex: 2
                        }
                        )
                    },
                    // Variance by Discipline
                    async () => {
                        this.getNewVTos({
                            id: this.allIds.variance,
                            stype: this.stype
                        },
                        [
                            ['偏差'],
                            ['bar']
                        ],
                        this.$refs.varDiscipline.myChart,
                        {
                            name: 'varDiscipline',
                            hasMoreData: ['s1'],
                            startIndex: 2
                        }
                        )
                    }
                ]
            }
        }
    }
</script>
<style lang="less" scoped>
    .banner{
        padding-top: 0.12rem;
    }
    .contentBox{
        height: 92%;
        .gridStyle(2, 6, 0.24rem, 0.1rem);
    }
</style>